import type ImageTile from "ol/ImageTile";
import TileState from "ol/TileState";

import {GeoserverTileApiInterface} from "../api/interface/geoserver-tile";
import {selectCredentials} from "./authSlice";
import type {RevaThunkAction} from "./revaHooks";
import type {RevaExtraArgs} from "./store";

/**
 * Async thunk to load a geoserver tile.
 * @param tile the tile that is loaded
 * @param url loaded URL for geoserver
 */
export const loadGeoserverTileAsync =
    (tile: ImageTile, url: string): RevaThunkAction<Promise<void>> =>
    async (_dispatch, getState, {serviceApi}: RevaExtraArgs) => {
        const credentials = selectCredentials(getState());
        if (!credentials) {
            console.warn("Can't load Geoserver tile without valid credentials!");
            return;
        }
        try {
            // console.debug(`Geoserver Tile query: ${url}`);
            const blobUrl = await new GeoserverTileApiInterface(url).execute(serviceApi, credentials);
            // getImage() is a union including HTMLCanvasElement (no .src); WMS/WMTS raster tiles
            // are always HTMLImageElement, so the cast is safe.
            (tile.getImage() as HTMLImageElement).src = blobUrl;
            tile.setState(TileState.LOADED);
        } catch (err) {
            console.warn(`Error loading geoserver tile: ${(err as Error).message}`);
            tile.setState(TileState.ERROR);
        }
    };
